import React, { useRef, useEffect } from 'react'
import gsap from 'gsap';
import { Link } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import { StreamCardProps, Stream } from '../../../../../types';
import { useDispatch } from 'react-redux';
import { setActualStreamActionCreator } from '../../../../../storage'


const Live = () => {

    let wrapper = useRef(null)

    useEffect(()=>{
        const [...elements] = wrapper.current.children;
        const tl = gsap.timeline({defaults: { ease: 'power3.inOut'}})
        gsap.set(elements, { autoAlpha: 0})
        tl.fromTo(elements,  { yoyo: true, scale: 0.1}, {duration: 0.6, scale: 1,autoAlpha: 1, stagger: 0.15, repeat: -1} )
    }, [])

    return(
        <div ref={wrapper} className="live__container">
            <p>L</p>
            <p>I</p>
            <p>V</p>
            <p>E</p>
        </div>
    )
}

const Planned = () => {

    return(
        <div className="planned__container">
            <p>P</p>
            <p>L</p>
            <p>A</p>
            <p>N</p>
            <p>N</p>
            <p>E</p>
            <p>D</p>
        </div>
    )
}



const StreamCard: React.FC<StreamCardProps> = (props) => {

    const dispatch = useDispatch();

    const handleClick = (item: Stream) => {
        dispatch(setActualStreamActionCreator( item ))
    }

    return (
        <Link to='/stream_details/' onClick={()=> {handleClick(props.props)}}>
        <div className="streamCard__container" >
                <div className="streamCard__foto">
                    <img src={props.props.photo} className="streamCardfoto__foto"/>
                </div>
                <div className="streamCard__details">
                    <div className="streamCard__title">{props.props.title} </div>
                    <div className="streamCard__author">{props.props.author} <div><FaEye/> {props.props.participants}</div></div>
                    <div className="streamCard__moreDetails">
                        <div className="streamCard__status">{props.props.status == 'live' ? <Live/> : <Planned/>}</div>
                        <div className="streamCard__description">{props.props.description}</div>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default StreamCard;
